import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { NumberPipe } from './number.pipe';
import { CurrencyPipe } from './currency.pipe';
import { PercentPipe } from './percent.pipe';
import { PhonePipe } from './phone.pipe';
import { DatePipe } from './date.pipe';
import { BooleanPipe } from './boolean.pipe';
import { HrefPipe } from './href.pipe';
import { PlaceholderPipe } from './placeholder.pipe';
import { TranslatePipe } from './translate.pipe';
import { DurationPipe } from './duration.pipe';
import { AnalyticsEventKeyPipe } from './analytics-event-key.pipe';
import { AnalyticsDatePipe } from './analytics-date.pipe';
import { QuantityPipe } from './quantity.pipe';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    NumberPipe,
    CurrencyPipe,
    PercentPipe,
    PhonePipe,
    DatePipe,
    BooleanPipe,
    HrefPipe,
    PlaceholderPipe,
    TranslatePipe,
    DurationPipe,
    AnalyticsEventKeyPipe,
    AnalyticsDatePipe,
    QuantityPipe
  ],
  exports: [
    NumberPipe,
    CurrencyPipe,
    PercentPipe,
    PhonePipe,
    DatePipe,
    BooleanPipe,
    HrefPipe,
    PlaceholderPipe,
    TranslatePipe,
    DurationPipe,
    AnalyticsEventKeyPipe,
    AnalyticsDatePipe,
    QuantityPipe
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    NumberPipe,
    PercentPipe,
    PhonePipe,
    AnalyticsEventKeyPipe,
    AnalyticsDatePipe
  ]
})
export class PipesModule {
}
